import React, { useMemo } from 'react';

const VacanciesItem = function({ vacancy }) {
  const {
          alternate_url,
          area,
          employer,
          salary,
          name,
          published_at,
        } = vacancy;

  const salaryText = useMemo(() => {
    if (!salary) {
      return '';
    }
    const {
            from,
            to,
          } = salary;
    return `${from ? `от ${from} ` : ''}${to ? `до ${to}` : ''} Br`;
  }, [salary]);

  const formattedDate = useMemo(() => new Date(published_at).toLocaleDateString('ru-RU', {
    month: 'long',
    day:   'numeric',
  }), [published_at]);

  return (
    <div className={'vacancy-item'}>
      <div className={'description'}>
        <div className={'title'}>
          <a
            href={alternate_url}
            target={'_blank'}
            rel={'nofollow noindex noreferrer'}
          >
            {name}
          </a>
        </div>
        <div className={'sub-title'}>{employer.name}, {formattedDate}</div>
      </div>
      <div className={'compensation'}>{salaryText}</div>
      <div className={'address'}>{area.name}</div>
    </div>
  );
};

export default VacanciesItem;